import { useContext, useEffect, useRef, useState } from "react";
import './imageCropper.scss';
import ReactCrop, { convertToPixelCrop } from "react-image-crop";
import setCanvasPreview from "./SetCanvarPreview";
import { Button } from "antd";
import { MultiStepFormData } from "../../Authentication/MultiStepForm/MultiStepForm";
import changeIcon from '../../../assets/images/change_icon.svg';
import uploadIcon from '../../../assets/images/upload_icon2.svg';
import { ShimmerThumbnail } from "react-shimmer-effects";

const ImageCropper = ({ dataHandle, type, duplicateImageUrl, imageCropperError, defaultHoverIcon, parent, maxWidth = 1920, maxHeight = 1080 }) => {
    const ASPECT_RATIO = type === 'wide' ? 2 / 1 : 1;
    const MIN_DIMENSION = 150;
    const MAX_WIDTH = maxWidth;
    const MAX_HEIGHT = maxHeight;
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB
    const context = useContext(MultiStepFormData);
    const formData = type === 'multiStepForm' ? context.formData : null;
    const setFormData = type === 'multiStepForm' ? context.setFormData : null;
    const imgRef = useRef(null);
    const previewCanvasRef = useRef(null);
    const [imgSrc, setImgSrc] = useState("");
    const [icon, setIcon] = useState();
    const [inputKey, setInputKey] = useState(Date.now());
    const [fileType, setFileType] = useState("image/jpeg");
    const [crop, setCrop] = useState({
        unit: '%',
        width: 100,
        height: 100 / ASPECT_RATIO,
        x: 0,
        y: 0
    });
    const [error, setError] = useState("");
    const [preview, setPreview] = useState(false);
    const [active, setActive] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (duplicateImageUrl) {
            const canvas = previewCanvasRef.current;
            const context = canvas.getContext('2d');
            const image = new Image();
            image.src = duplicateImageUrl;

            image.onload = () => {
                canvas.width = image.naturalWidth;
                canvas.height = image.naturalHeight;
                context.drawImage(image, 0, 0, canvas.width, canvas.height);
            };
        }
    }, [duplicateImageUrl]);

    const onSelectFile = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        // Set the file type for later use
        setFileType(file.type);

        if (file.size > MAX_FILE_SIZE) {
            setError("Image size must not exceed 5 MB.");
            return;
        }

        const reader = new FileReader();
        reader.addEventListener("load", () => {
            const imageElement = new Image();
            const imageUrl = reader.result?.toString() || "";
            imageElement.src = imageUrl;

            imageElement.addEventListener("load", (e) => {
                if (error) setError(""); // Clear previous errors
                const { naturalWidth, naturalHeight } = e.currentTarget;

                if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
                    setError("Image must be at least 150 x 150 pixels.");
                    return;
                }

                setImgSrc(imageUrl);
                setActive(true); // Allow cropping UI to show up
            });
        });
        reader.readAsDataURL(file);
        setInputKey(Date.now());
    };

    const onImageLoad = (e) => {
        const { width, height } = e.currentTarget;

        let cropWidth = width;
        let cropHeight = width / ASPECT_RATIO;

        if (cropHeight > height) {
            cropHeight = height;
            cropWidth = height * ASPECT_RATIO;
        }

        const crop = {
            unit: 'px',
            width: cropWidth,
            height: cropHeight,
            x: (width - cropWidth) / 2,
            y: (height - cropHeight) / 2,
        };
        setCrop(crop);
    };

    const handleCropImage = (e) => {
        e.preventDefault();

        setCanvasPreview(
            imgRef.current,
            previewCanvasRef.current,
            convertToPixelCrop(crop, imgRef.current.width, imgRef.current.height)
        );

        // Reduce quality when converting the canvas to Base64
        const dataUrl = previewCanvasRef.current.toDataURL(fileType, fileType === "image/jpeg" ? 0.7 : 1.0);
        setPreview(true);
        setActive(false);
        dataHandle(false, dataUrl);

        if (type === 'multiStepForm' && setFormData) {
            setFormData({ ...formData, logoUrl: dataUrl });
        }
    };


    useEffect(() => {
        imageCropperError(error);
    }, [error]);

    const iconChange = () => {
        if (!imgSrc && defaultHoverIcon !== 'change') {
            return uploadIcon;
        } else {
            return uploadIcon;
        }
    };

    useEffect(() => {
        setIcon(iconChange());
    }, [imgSrc, defaultHoverIcon]);

    useEffect(() => {
        console.log('previewCanvasRef', previewCanvasRef)
    }, [previewCanvasRef])

    return (
        <div className="crop">
            {error && <p className="crop_error">{error}</p>}
            <div className="hover_preview">
                <div className="cnt">
                    <figure className="mb-0"><img className="icon" src={icon} alt="" /></figure>
                </div>
            </div>
            <label className="block mb-3 w-fit">
                <input
                    type="file"
                    accept="image/*"
                    onChange={onSelectFile}
                    className=""
                    key={inputKey}
                />
            </label>
            {imgSrc && (
                <div className={` ${active ? "crop_preview" : "crop_preview inactive"}`} style={{ width: "auto" }}>
                    <Button type="primary" onClick={() => setActive(false)} className="close_crop" />
                    <ReactCrop
                        className="image_cropper"
                        crop={crop}
                        onChange={(newCrop) => setCrop({ ...crop, ...newCrop })}
                        keepSelection
                        aspect={ASPECT_RATIO}
                        minWidth={MIN_DIMENSION}
                    >
                        <img
                            ref={imgRef}
                            src={imgSrc}
                            alt="Upload"
                            style={{ maxHeight: "70vh" }}
                            onLoad={onImageLoad}
                        />
                    </ReactCrop>
                    <Button
                        type="primary"
                        style={{ color: "#fff ", marginTop: "1em" }}
                        onClick={handleCropImage}
                    >
                        Crop Image
                    </Button>
                </div>
            )}
            <div className="img_holder" style={{ overflow: "hidden", height: formData?.logoUrl ? "100%" : null, borderRadius: "15px" }}>
                {
                    parent === 'multiStepForm' ? (
                        <canvas
                            ref={previewCanvasRef}
                            className="mt-4"
                            style={{
                                display: (formData?.logoUrl || preview || duplicateImageUrl) ? 'block' : 'none',
                                width: "100%",
                                height: "100%",
                            }}
                        />
                    ) : (
                        !error && (
                            <canvas
                                ref={previewCanvasRef}
                                className="mt-4"
                                style={{
                                    display: (formData?.logoUrl || preview || duplicateImageUrl) ? 'block' : 'none',
                                    width: "100%",
                                    height: "100%",
                                }}
                            />
                        )
                    )
                }
                {
                    !previewCanvasRef && (
                        <div className="image_shimmer">
                            <ShimmerThumbnail height={200} width={300} />
                        </div>
                    )
                }
            </div>

        </div>
    );
};

export default ImageCropper;
